import { TranslationId } from '../transloco';
import { NotificationOptions } from './model/notification-options';
import { NotificationType } from './model/notification-type';
import { PartialNotification } from './model/partial-notification';

export class ShowRefreshNotification implements PartialNotification {
  static readonly type = '[Notification] Show refresh notification';
  readonly notificationType: NotificationType = 'refresh';

  constructor(public message: TranslationId, public options?: Partial<NotificationOptions>) {}
}

export class ShowInfoNotification implements PartialNotification {
  static readonly type = '[Notification] Show info notification';
  readonly notificationType: NotificationType = 'info';

  constructor(public message: TranslationId, public options?: Partial<NotificationOptions>) {}
}

export class ShowSuccessNotification implements PartialNotification {
  static readonly type = '[Notification] Show success notification';
  readonly notificationType: NotificationType = 'success';

  constructor(public message: TranslationId, public options?: Partial<NotificationOptions>) {}
}

export class ShowWarningNotification implements PartialNotification {
  static readonly type = '[Notification] Show warning notification';
  readonly notificationType: NotificationType = 'warning';

  constructor(public message: TranslationId, public options?: Partial<NotificationOptions>) {}
}

export class ShowErrorNotification implements PartialNotification {
  static readonly type = '[Notification] Show error notification';
  readonly notificationType: NotificationType = 'error';

  constructor(public message: TranslationId, public options?: Partial<NotificationOptions>) {}
}

export class DismissNotification {
  static readonly type = '[Notification] Dismiss notification';

  constructor(public id: symbol) {}
}

export class ClearNotifications {
  static readonly type = '[Notification] Clear notifications';

  tags: (symbol | string)[];

  constructor(...tags: (symbol | string)[]) {
    this.tags = tags;
  }
}
